import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/card.css";
import TaskStatus from "./TaskStatus";
import GreenIcon from "../assets/img/green-tick.png";
import OrangeIcon from "../assets/img/clockicon.png";
import BlueIcon from "../assets/img/clock-icon.png";
import WaitIcon from "../assets/img/icon.png";

const Card = (props) => {
  const iconClass = `${props.icon} mt-1`;
  return (
    <div className="card mb-4" aria-disabled={props?.isOnboarding}>
      
      {" "}
      <div class={`card-body ${props.status ? props.status : ""}`} style={{ backgroundColor:  props?.isDisabled || (props?.isOnboarding && props?.cardHeading == "Personal Details") ? "#dfe1e2" : "" }} >
        {" "}
        <div class="d-flex justify-content-between align-items-start">
          {" "}
          <i className={iconClass}  style={{fontSize: '2rem'}}></i>
          <TaskStatus icon={(props.cardStatus=="0"? WaitIcon:props.cardStatus=="1"? GreenIcon:BlueIcon)} text={(props.cardStatus=="0"? "Pending":props.cardStatus=="1"?"Completed":"In Progress" )} color={props.status} />
          {" "}
                               
        </div>{" "}               
        <h5 class="card-title fnt-bld">{props.cardHeading}</h5>{" "}
        <div class="card-text text-muted"> {props.cardText} </div>{" "}
      </div>{" "}                                                             
    </div>
  );
};

export default Card;
